import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { DataStorageService } from '../services/data-storage.service';
import { LoggedInUserInfo } from '../model/LoggedInUserInfo';
import { CommonService } from '../services/common-service.service';
import { environment } from 'src/environments/environment';
import { AlertService } from "src/app/service/alert.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private alertify: AlertService) { }

  canActivate(): boolean {
    if (this.authService.loggedIn()) {
      return true;
    }
    this.alertify.error('Please login to continue...');
    document.location.href = environment.intranetLogin;
    return false;
  }
}

// @Injectable({
//   providedIn: 'root'
// })
// export class AuthGuard implements CanActivate {
//   user: LoggedInUserInfo = {
//     UserName: "",
//     UserID: 0,
//     Token: ""
//   };
//   isSession = false;
//   sosApiEndPoint = environment.sosApiEndPoint;
//   constructor(public authService: AuthService, private dataService: DataStorageService, private commonService: CommonService,
//     public router: Router) { }

//   canActivate(next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
//     // Guard for user is login or not
//     let res = false;
//     let user = JSON.parse(localStorage.getItem('UserID'));
//     // //debugger
//     if (!user || user === null) {
//       //debugger
//       // this.checkUser();
//       this.commonService.logoutRedirect();
//       // this.router.navigate(['/cab/add-cab-booking']);
//     }
//     else {
//       // console.log("Check URL")
//       let token = localStorage.getItem("token");
//       //debugger
//       // let resp = await this.commonService.getSession(token);
//       // res = resp[0];
//       return new Promise((resolve, reject) => {
//         this.dataService.getSoSData(this.sosApiEndPoint + "api/Authenticate/SessionActive/" + token).subscribe((response) => {
//           let result = <any>response;
//           if (result) {
//             resolve(true);
//           }
//           else {
//             this.commonService.logoutRedirect();
//           }
//         })
//       })


//     }

//   }

// }
